import { FunctionComponent, useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import LoadingWidget from "../../../../context_providers/modal/loader";
import {
  useToast,
  ToastType,
} from "../../../../context_providers/toast/toast_ctx";
import { urls } from "../../../../utils/urls";
import { gst_rates, tax_type } from "../../../accounts/models/ledger_model";
import {
  ItemModelV2Default,
  ItemModel,
  ItemModelV2,
} from "../../models/item_model";
import ProductItemCreationForm from "../components/product_item_creation_form";
import ServiceItemCreationForm from "../components/service_item_creation_form";
import { useAuth } from "../../../../context_providers/auth/authProvider";
import { getSingleItemRepo, deleteItem } from "../repository/items_repository";
import { ACTION, MasterItemStatus, MODULE } from "../../../../utils/enums";
import ModalWidget from "../../../../context_providers/modal/modal_widget";
import { ModalType } from "../../../../context_providers/modal/modal_context";
import { QRCodeSVG } from "qrcode.react";
import "../../../../styles/responsive_shrink.css";
import { Clock } from "react-feather";
import EntityHistory, {
  GetItemLogsByEntityApi,
} from "../../../purchase_order/purchase_order_create/components/entity_logs";
import DrawerModal, {
  DrawerModalLoaction,
} from "../../../../ui/new_components/common/drawer_modal";
interface ItemCreateScreenProps {
  data?: ItemModelV2;
  onClose: (id: ItemModel) => void;
}

const ItemViewScreen: FunctionComponent<ItemCreateScreenProps> = (props) => {
  const { id } = useParams<{ id: string }>();
  const navaigation = useHistory();
  const is_delete_page = useRouteMatch(
    urls.procurement_masters_item + "/delete/:id",
  );
  const [loading, setLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [selectedType, setSelectedType] = useState<"Product" | "Service">(
    "Product",
  );
  const { isAuthorised } = useAuth();
  const [canEdit, setCanEdit] = useState(true);
  const [checker, setChecker] = useState<boolean>(false);
  const { showToast } = useToast();
  const [data, setData] = useState<ItemModelV2>({
    ...(props.data || { ...ItemModelV2Default }),
  });
  const [showQrCodeModal, setQrCodeModal] = useState<boolean>(false);
  const [qrCodeData, setQRCodeData] = useState<string>("");
  const [productData, setProductData] = useState<ItemModelV2>({
    ...(props.data || { ...ItemModelV2Default }),
  });
  const [serviceData, setServiceData] = useState<ItemModelV2>({
    ...(props.data || { ...ItemModelV2Default }),
  });

  const getData = async (id: string) => {
    setLoading(true);
    const res = await getSingleItemRepo(id);
    if (res.success) {
      console.log("res", res.data);
      if (res.data.type === "Product") {
        setProductData(res.data);
        let stringifiedData = JSON.stringify({
          item_code: res.data.item_code,
          item_name: res.data.name,
        });
        setQRCodeData(stringifiedData);
      } else if (res.data.type === "Service") {
        setServiceData(res.data);
        let stringifiedData = JSON.stringify({
          item_code: res.data.item_code,
          item_name: res.data.name,
        });
        setQRCodeData(stringifiedData);
      } else setData(res.data);
      setData(res.data);
      setSelectedType(res.data.type);
    } else showToast({ type: ToastType.error, text: res.error });
    setLoading(false);
  };

  const approveRejectDeleteItem = async (status: MasterItemStatus) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this item? Click 'OK' to confirm or 'Cancel' to abort.",
    );
    if (!confirmed) {
      return; // Abort the operation if the user clicks 'Cancel'
    }
    setLoading(true);
    data.status = status;
    data.deleted = true;
    const result = await deleteItem(data);
    if (result.success) {
      showToast({
        type: ToastType.success,
        text: "Item deleted request successfull",
      });
      navaigation.goBack();
    } else {
      showToast({ type: ToastType.error, text: result.error });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (id) {
      getData(id); // Fetch data only once when the component mounts.
    }
    setCanEdit(false);

    const checker_result = isAuthorised({
      module: MODULE.master_item_checker,
      action: ACTION.UPDATE,
    });

    setChecker(checker_result);
  }, [id]);

  return (
    <div className="mobile-shrink">
      {showQrCodeModal && (
        <ModalWidget
          data={{
            id: 1,
            title: "QR Code",
            type: ModalType.modal,

            onClose: () => {
              setQrCodeModal(false);
            },
          }}
          onClose={function (): void {
            setQrCodeModal(false);
          }}
        >
          <div id="qr_code_modal" className="gap-4">
            <div className="flex flex-col md:flex-row text-sm w-full mb-4">
              <label className="font-semibold w-full" htmlFor="item_code">
                Item Code
              </label>
              <input
                placeholder="Item Code"
                className="p-1 rounded focus:outline-none w-full border"
                id="item_code"
                name="item_code"
                value={data.item_code || ""}
                disabled={true}
                type="text"
                onChange={(e) => {
                  setData({ ...data, item_code: e.target.value });
                }}
              ></input>
            </div>
            <div className="flex flex-col md:flex-row text-sm w-full">
              <label className="font-semibold w-full" htmlFor="name">
                Item Name
              </label>
              <input
                placeholder="Item Name"
                className="p-1 rounded focus:outline-none w-full border"
                id="name"
                name="name"
                value={data.name || ""}
                disabled={true}
                type="text"
                onChange={(e) => {
                  setData({ ...data, name: e.target.value });
                }}
              ></input>
            </div>
            <div className="flex justify-center my-4">
              <QRCodeSVG value={qrCodeData} />
            </div>
            <div className="flex justify-center">
              <button
                id="print_btn"
                onClick={() => window.print()}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              >
                Print
              </button>
            </div>
          </div>
        </ModalWidget>
      )}
      <div className="flex flex-col m-1 md:m-4 gap-1 md:gap-4">
        <section id="top_section" className=" ">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold border-l-4 border-myPrimaryColor pl-2">
              {is_delete_page ? "Item Delete" : "Item Details"}
            </h1>
            {data.item_code && (
              <button
                id="history_btn"
                type="button"
                onClick={() => setShowHistory(true)}
                className="flex items-center gap-1 text-sm hover:text-gray-600  text-myPrimaryColor"
                title="View History"
              >
                <Clock size={32} />
              </button>
            )}
          </div>
        </section>
        <section className="m-2 md:m-4">
          <div className="font-bold">Item Type</div>
          <div className="flex flex-row gap-4">
            <div className="items-center">
              <input
                id="item_type_product"
                type="radio"
                name="itemType"
                value="Product"
                disabled={!canEdit}
                checked={selectedType === "Product"}
                onChange={(e) =>
                  setSelectedType(e.target.value as "Product" | "Service")
                }
              />
              <label className="ml-2">Product</label>
            </div>
            <div className="flex items-center">
              <input
                id="item_type_service"
                type="radio"
                name="itemType"
                value="Service"
                checked={selectedType === "Service"}
                disabled={!canEdit}
                onChange={(e) => {
                  setData((o) => ({
                    ...o,
                    type: e.target.value as "Product" | "Service",
                  }));
                  setSelectedType(e.target.value as "Product" | "Service");
                }}
              />
              <label className="ml-2">Service</label>
            </div>
          </div>
        </section>
      </div>
      {selectedType === "Product" ? (
        <ProductItemCreationForm
          data={productData}
          setData={setProductData}
          canEdit={canEdit}
        />
      ) : (
        <ServiceItemCreationForm
          data={serviceData}
          setData={setServiceData}
          canEdit={canEdit}
        />
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 m-2 md:m-3 gap-2 select-none">
        <div className="p-5 md:p-10 flex flex-col gap-5 shadow bg-white  rounded-lg">
          <h4 className="font-semibold"> Tax details </h4>
          <div className="flex flex-row gap-6">
            <div className="flex gap-3 items-center">
              <input
                type="radio"
                id="tax_yes"
                name="tax_applicable"
                value="yes"
                checked={
                  selectedType === "Product"
                    ? productData.tax_applicable
                    : selectedType === "Service"
                      ? serviceData.tax_applicable
                      : data.tax_applicable
                }
                onChange={() => {
                  if (selectedType === "Product") {
                    setProductData((o) => ({ ...o, tax_applicable: true }));
                  } else if (selectedType === "Service") {
                    setServiceData((o) => ({ ...o, tax_applicable: true }));
                  }
                  setData((o) => ({ ...o, tax_applicable: true }));
                }}
                disabled={!canEdit}
              />
              <label htmlFor="tax_yes">Yes</label>
            </div>
            <div className="flex gap-3 items-center">
              <input
                type="radio"
                id="tax_no"
                name="tax_applicable"
                value="no"
                checked={
                  selectedType === "Product"
                    ? !productData.tax_applicable
                    : selectedType === "Service"
                      ? !serviceData.tax_applicable
                      : !data.tax_applicable
                }
                onChange={() => {
                  if (selectedType === "Product") {
                    setProductData((o) => ({
                      ...o,
                      tax_applicable: false,
                    }));
                  } else if (selectedType === "Service") {
                    setServiceData((o) => ({
                      ...o,
                      tax_applicable: false,
                    }));
                  }
                  setData((o) => ({ ...o, tax_applicable: false }));
                }}
                disabled={!canEdit}
              />
              <label htmlFor="tax_no">No</label>
            </div>
          </div>
          {selectedType === "Product" || selectedType === "Service" ? (
            <>
              {(selectedType === "Product"
                ? productData.tax_applicable
                : serviceData.tax_applicable) && (
                <>
                  <div className="flex flex-col items-start text-sm w-full">
                    <label className="font-semibold w-full" htmlFor="tax_type">
                      Tax type{"*"}
                    </label>
                    <select
                      value={
                        selectedType === "Product"
                          ? productData.tax_detail?.type || "default"
                          : serviceData.tax_detail?.type || "default"
                      }
                      disabled={!canEdit}
                      onChange={(e) => {
                        const updatedType = e.target.value;
                        if (selectedType === "Product") {
                          setProductData((prev) => ({
                            ...prev,
                            tax_detail: {
                              ...prev.tax_detail,
                              type: updatedType,
                              hsn_sac: prev.tax_detail?.hsn_sac || "",
                            },
                          }));
                        } else {
                          setServiceData((prev) => ({
                            ...prev,
                            tax_detail: {
                              ...prev.tax_detail,
                              type: updatedType,
                              hsn_sac: prev.tax_detail?.hsn_sac || "",
                            },
                          }));
                        }
                      }}
                      name="tax_type"
                      id="tax_type"
                      className="p-1 rounded focus:outline-none w-full border"
                    >
                      <option value="default" disabled>
                        Select a tax type
                      </option>
                      {Object.values(tax_type).map((type, i) => (
                        <option value={type} key={i}>
                          {type.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex gap-5 items-center text-sm w-full">
                    {(selectedType === "Product"
                      ? productData.tax_detail.type === tax_type.gst
                      : serviceData.tax_detail.type === tax_type.gst) && (
                      <>
                        <div className="flex flex-col items-start text-sm w-full">
                          <label className="font-semibold w-full" htmlFor="hsn">
                            GST Rate*
                          </label>
                          <select
                            id="gstRate"
                            className="border border-gray-300 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={
                              selectedType === "Product"
                                ? productData.tax_detail?.gst_rate || "default"
                                : serviceData.tax_detail?.gst_rate || "default"
                            }
                            disabled={!canEdit}
                            onChange={(e) => {
                              const gstRate = Number(e.target.value);
                              if (selectedType === "Product") {
                                setProductData((prev) => ({
                                  ...prev,
                                  tax_detail: {
                                    ...prev.tax_detail,
                                    gst_rate: gstRate,
                                  },
                                }));
                              } else {
                                setServiceData((prev) => ({
                                  ...prev,
                                  tax_detail: {
                                    ...prev.tax_detail,
                                    gst_rate: gstRate,
                                  },
                                }));
                              }
                            }}
                          >
                            <option value="" disabled>
                              Select GST Rate
                            </option>
                            {gst_rates.map((rate) => (
                              <option key={rate} value={rate}>
                                {rate}%
                              </option>
                            ))}
                          </select>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </>
          ) : null}
        </div>
        {!is_delete_page && (
          <div className="p-5 md:p-10 flex flex-col gap-5 shadow bg-white  rounded-lg">
            <div className="flex flex-col items-start text-sm w-full">
              <label className="font-semibold w-full" htmlFor="remarks">
                Remarks/Notes
              </label>
              <textarea
                placeholder="Enter Remarks/Notes"
                className="p-1 rounded  focus:outline-none w-full border"
                id="remarks"
                name="remarks"
                disabled={is_delete_page ? false : true}
                value={
                  selectedType === "Product"
                    ? productData.remarks
                    : selectedType === "Service"
                      ? serviceData.remarks
                      : data.remarks
                }
                onChange={(e) => {
                  if (selectedType === "Product") {
                    setProductData((o) => ({
                      ...o,
                      remarks: e.target.value,
                    }));
                  } else if (selectedType === "Service") {
                    setServiceData((o) => ({
                      ...o,
                      remarks: e.target.value,
                    }));
                  }
                  setData((o) => ({
                    ...o,
                    remarks: e.target.value,
                  }));
                }}
              ></textarea>
            </div>
          </div>
        )}
      </div>
      <div className="m-2 md:m-4">
        <div className="flex flex-wrap justify-end mt-5 mb-2">
          {is_delete_page && checker ? (
            <>
              <div className="flex m-2 md:m-4">
                <button
                  id="delete_btn"
                  onClick={() => {
                    approveRejectDeleteItem(MasterItemStatus.Approved);
                  }}
                  type="button"
                  className="rounded-md text-sm font-semibold bg-red-400 text-white px-3 py-1"
                >
                  Delete
                </button>
              </div>
            </>
          ) : null}

          <div className="m-2 md:m-4">
            {(selectedType === "Product" &&
              productData.status === "Approved") ||
            (selectedType === "Service" &&
              serviceData.status === "Approved") ? (
              <button
                id="generate_qr_btn"
                onClick={() => {
                  setQrCodeModal(true);
                }}
                type="button"
                className="rounded-md text-sm font-semibold bg-myPrimaryColor text-black px-3 py-1"
              >
                Generate QR Code
              </button>
            ) : null}
          </div>
          <div className="m-2 md:m-4">
            <button
              id="quit_btn"
              onClick={() => {
                navaigation.goBack();
              }}
              type="button"
              className="rounded-md text-sm font-semibold bg-white text-black px-3 py-1"
            >
              Quit
            </button>
          </div>
        </div>
      </div>

      {loading && <LoadingWidget />}
      {showHistory && (
        <DrawerModal
          location={DrawerModalLoaction.right}
          show={showHistory}
          onClose={() => setShowHistory(false)}
          title="Item History"
        >
          <EntityHistory
            fetchLogs={({ page, count }) =>
              GetItemLogsByEntityApi({
                item_code: data.item_code,
                page,
                count,
              })
            }
          />
        </DrawerModal>
      )}
    </div>
  );
};

export default ItemViewScreen;
